import { BuilderComponentGroup } from '../types'

export const CTA: BuilderComponentGroup = {
  id: 'cta',
  title: 'CTA',
  components: [
    {
      compId: 'cta-1',
      title: 'CTA 1',
      icon: 'HeroSimple',
      nested: false,
      isDesignBlock: true,
      settings: {},
    },
    {
      compId: 'cta-2',
      title: 'CTA 2',
      icon: 'HeroSimple',
      nested: false,
      isDesignBlock: true,
      settings: {},
    },
    {
      compId: 'cta-3',
      title: 'CTA 3',
      icon: 'HeroSimple',
      nested: false,
      isDesignBlock: true,
      settings: {},
    },
    {
      compId: 'cta-4',
      title: 'CTA 4',
      icon: 'HeroSimple',
      nested: false,
      isDesignBlock: true,
      settings: {},
    },
    {
      compId: 'cta-5',
      title: 'CTA 5',
      icon: 'HeroSimple',
      nested: false,
      isDesignBlock: true,
      settings: {},
    },
    {
      compId: 'cta-6',
      title: 'CTA 6',
      icon: 'HeroSimple',
      nested: false,
      isDesignBlock: true,
      settings: {},
    },
    {
      compId: 'cta-7',
      title: 'CTA 7',
      icon: 'HeroSimple',
      nested: false,
      isDesignBlock: true,
      settings: {},
    },
    {
      compId: 'cta-8',
      title: 'CTA 8',
      icon: 'HeroSimple',
      nested: false,
      isDesignBlock: true,
      settings: {},
    },
  ],
}
